import signinServiceConfig from './service/signin.service.json'
import signupServiceConfig from './service/signup.service.json'
import forgotPasswordServiceConfig from './service/forgotPassword.service.json'
import resetPasswordSelfServiceConfig from './service/resetPassword.service.json'
import updatePasswordServiceConfig from './service/updatePassword.service.json'
import commonServiceConfig from './service/common.service.json'
import parentsVerificationConfig from './service/parentsVerification.service.json'
import facebookServiceConfig from './service/facebook.service.json'
import privacyManagementServiceConfig from './service/privacyManagement.service.json'
import walletServiceConfig from './service/wallet.service.json'
import agencyWalletServiceConfig from './service/agencyWallet.service.json'
import userProfileServiceConfig from './service/userProfile.service.json'
import logoutServiceConfig from './service/logout.service.json'
import securitySettingServiceConfig from './service/securitySetting.service.json'
import updateAccountServiceConfig from './service/updateAccount.service.json'
import shippingAddressServiceConfig from './service/shippingAddress.service.json'
import widgetTokenServiceConfig from './service/widgetToken.service.json'

const signInUpServiceConfig = signinServiceConfig.concat(
  signupServiceConfig,
  forgotPasswordServiceConfig,
)

const resetPasswordServiceConfig = resetPasswordSelfServiceConfig.concat(forgotPasswordServiceConfig)

export {
  signInUpServiceConfig,
  forgotPasswordServiceConfig,
  resetPasswordServiceConfig,
  updatePasswordServiceConfig,
  commonServiceConfig,
  parentsVerificationConfig,
  facebookServiceConfig,
  privacyManagementServiceConfig,
  walletServiceConfig,
  agencyWalletServiceConfig,
  userProfileServiceConfig,
  logoutServiceConfig,
  securitySettingServiceConfig,
  updateAccountServiceConfig,
  shippingAddressServiceConfig,
  widgetTokenServiceConfig,
}

export * from './PageUrls'
